module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldSemiCn.2dbd58b.eot";